const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

const getDayName = (date) => days[date.getDay()];

export default getDayName;